var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app-container" }, [
    _vm.url
      ? _c("div", { staticClass: "block" }, [
          _c("iframe", {
            attrs: {
              src: _vm.url,
              width: "100%",
              height: _vm.ifheight + "px",
              frameborder: "0",
              scrolling: "auto",
            },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }